<template>
  <div class="centerdiv">
    <h2>出题</h2>
    <el-row>
      <el-col :span=8>
        <el-row class="rowheight">
          <el-col :span="6" class='labright'>类别1</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.type1" placeholder="显示到最上方的类别"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>类别2</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.type2" placeholder="备用，尚未用到"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>关键词</el-col>
          <el-col :span="18" class='xtextleft'>
            <el-input v-model="pInfo.keyword" placeholder="会显示到类别1的下方"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>标题</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.title" placeholder="此处文字会显示到正文中，可写可不写，最好写上"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>原作者</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.author2"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>答案类型</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.atype" placeholder="0为输入，1为单选题，2为多选题"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>答案标记</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.amark" placeholder="即显示在输入答案前的提示，同时也是选择题选项"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>答案是否数值</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.aisnumber" placeholder="数值为1，字符为0，逗号分隔，，如果是多个输入，需要全写，如三个是1,1,1"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>答案格式</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.aformat" placeholder="答案格式，如输入一个整数，输入一个字符，输入一个小数，保留两位小数等，多个用逗号分隔"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>答案</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.answer" placeholder="答案，多个用逗号分隔"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>keyword2</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.keyword2" placeholder="用于生成静态页面的keywords，尽量多填"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>description</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.description" placeholder="description"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>动画js名称</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.animateJSNames" placeholder="只写名称如12k_pid_6,forward_1等，不加.js"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <input  type="file" ref="file" @change="onChange" accept="image/*" />
        </el-row>
        <el-row style="padding: 16px;">
          <el-col :span="6" >
            <el-button type="primary" @click="submitUpload" style="width:150px">上传图片到服务器</el-button>
          </el-col>
          <el-col :span="18" >
            <el-button type="primary" @click="commit" style="width:150px">提交题目</el-button>
          </el-col>
          <el-col :span="18" >
            <el-button type="" @click="commit2knowledge" style="width:250px">提交本题到知识点,需先提交为题目</el-button>
          </el-col>
        </el-row>
        <el-row>
          <div id="app-4">
            <ol>
              <li v-for="fn in imgFileList" :key="fn.url">
                {{ fn.url }}
              </li>
            </ol>
          </div>
        </el-row>
      </el-col>
      <el-col :span=16>
        <div id="standalone-container" style="margin: 10px auto;max-width: 98%;height: 98%;">
          <div id="toolbar">

          </div>
          <div id="editor" style="height: calc(100vh - 230px);"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { addNewProblem2pre } from '@/api/problems'
  import { setEditor } from '@/utils/quill.table'
  import { getUUID } from '@/utils/index.js'
  import { addNewKnowledge} from '@/api/api_knowledge.js'

  export default {
    data () {
      return {
        imgFileList: [],
        imgFile: null,
        imgFile2: '',
        value: '',
        pInfo: {
          type1: '',
          type2: '',
          type3: '',
          type4: '',
          keyword: '',
          title: '',
          content: '',
          aisnumber: '',
          aformat: '',
          atype: '',
          amark: '',
          answer: '',
          author2: '', // 题目原作者
          animateJSNames: '',
          description: '',
          keyword2: ''
        },
        kInfo: {
          guid: '',
          title: '',
          type: '',
          content: '',
          author2Guid: '', // 知识点原作者
          description: '',
          keyword2: ''
        },
        quill: null,
        toolbarOptions: [
          // ['contain'],
          [{'table': ['newtable_1_1', 'newtable_1_2', 'newtable_1_3', 'newtable_1_4', 'newtable_1_5', 'newtable_2_1', 'newtable_2_2', 'newtable_2_3', 'newtable_2_4', 'newtable_2_5', 'newtable_3_1', 'newtable_3_2', 'newtable_3_3', 'newtable_3_4', 'newtable_3_5']}],
          [{'table': 'append-row'}],
          [{'table': 'append-col'}],
          [{'table': 'remove-row'}], // cursor needs to be in the table
          [{'table': 'remove-col'}], // cursor needs to be in the table
          [{'table': 'remove-table'}], // cursor needs to be in the table
          [{'table': 'cell-background'}],
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{'header': 1}, {'header': 2}],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'script': 'sub'}, {'script': 'super'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          [{'direction': 'rtl'}],
          [{'size': ['small', false, 'large', 'huge']}],
          [{'header': [1, 2, 3, 4, 5, 6, false]}],
          [{'color': []}, {'background': []}],
          [{'align': []}],
          ['link', 'image'],
          ['formula', 'clean', 'video']
        ]
      }
    },
    computed: {
      ...mapGetters([
        'welcome'
      ])
    },
    created () {
      // this.tableHandler()
      // container: this.toolbarOptions,
    },
    mounted () {
      this.quill = new window.Quill('#editor', {
        modules: {
          formula: true,
          syntax: true,
          toolbar: {
            container: this.toolbarOptions,
            handlers: {
              image: this.imageHandler
            }
          }
        },
        placeholder: 'Compose an epic...',
        theme: 'snow'
      })
      setEditor(this.quill)
    },
    methods: {
      imageHandler () {
        console.log('65')
        var range = this.quill.getSelection()
        var value = prompt('What is the image URL')
        this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER)
      },
      //新增为知识点
      commit2knowledge(){
          this.kInfo.title = this.pInfo.title
          this.kInfo.content =this.pInfo.content  
          this.kInfo.type = this.pInfo.type1
          this.kInfo.author2Guid = this.pInfo.author2
          this.kInfo.keyword2=this.pInfo.keyword2
          this.kInfo.description=this.pInfo.description

          addNewKnowledge(this.kInfo).then((res) => {
            if (res.data) {
              if (res.data.isOk === true) {
                this.showMsg('添加知识点成功。', 'info')
              } else {
                this.showMsg('添加知识点失败。', 'info')
              }
            } else {
              this.showMsg('添加知识点不成功。', 'info')
            }
          }).catch(err => {
            this.showMsg(`添加知识点失败。${err}`)
          })
      },
      commit () {
        this.pInfo.content = JSON.stringify(this.quill.getContents())
        // console.log('this.quill.getContents=' + JSON.stringify(this.quill.getContents()))
        addNewProblem2pre(this.pInfo).then((res) => {
          if (res.data) {
            // console.log('res.data.isOk--' + JSON.stringify(res.data.isOk))
            if (res.data.isOk === true) {
              this.showMsg('保存新题成功。', 'info')
            } else {
              this.showMsg('添加题目失败。', 'info')
            }
          } else {
            this.showMsg('保存新题不成功。', 'info')
          }
        }).catch(err => {
          this.showMsg(`保存新题失败。${err}`)
        })
      },
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '出题',
          message: msg,
          type: type
        })
      },
      submitUpload () {
        /* let isJPG = (this.imgFile2.type === 'image/jpeg' || this.imgFile2.type === 'image/png')
        let isLt1M = this.imgFile2.size / 1024 / 1024 < 1

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
          return
        }
        if (!isLt1M) {
          this.$message.error('上传头像图片大小不能超过1MB!')
          return
        } */
        if (window.FormData) {
          var objectkey = 'problemImg/' + getUUID() + '.jpg'
          console.log(objectkey)
          // var co = require('co')
          var OSS = require('ali-oss')
          var client = new OSS.Wrapper({
            region: 'oss-cn-shanghai',
            accessKeyId: 'LTAIUbDiVeNi1iCH',
            accessKeySecret: 'lvtggZAvoZ5mthqkgBD89qnmB892Jq',
            bucket: 'longmathimg'
          })
          console.log(this.imgFile)
          client.put(objectkey, Buffer.from(this.imgFile)).then(r2 => {
            this.imgFileList.push(r2)
            console.log('get success: ', r2)
          }).catch(err => {
            console.log(err)
          })
        }
      },
      onChange (event) {
        var file = event.target.files[0]
        /* if (!/image\/\w+/.test(file)) {
          console.log('图片格式不正确')
          return false
        } */
        this.imgFile2 = file
        var reader = new FileReader()
        let self = this
        reader.onload = function (event) {
          // 文件里的文本会在这里被打印出来
          self.imgFile = event.target.result
          console.log(self.imgFile)
        }
        reader.readAsArrayBuffer(file)
      }
    }
  }
</script>

<style scoped>
  .centerdiv {
    height: auto;
    text-align: center;
  }

  .labright {
    height: 50px;
    line-height: 40px;
    text-align: right;
    vertical-align: middle;
  }
  .rowheight{
    text-align: right;
    vertical-align: middle;
  }
  .textleft {
    text-align: left;
    height: 30px;
  }

  .lableft {
    text-align: left;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// CreateProblem.vue?3d48f192